import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup, CheckBox, List } from "devextreme-react";
import { lastStep, nextStep, setDataForms, doUploadFile, doDeleteSingleFile, setStep } from "../../actions";
import helper from "../../../../../../../helpers/validaciones";
import FileUploaderField from "../../../../../../Shared/fields/FileUploaderField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import NumberField from "../../../../../../Shared/fields/NumberField";

const maxFileSize = process.env.REACT_APP_MAX_FILE_FIELD_SIZE_UPLOAD_IN_BM * 1000000

const DocumentType = {
  fun: "FUN",
}

class InfoPrevisional extends React.PureComponent {
  constructor(props) {
    super(props);

    this.topRef = React.createRef();
    if (!props.jsonData.formInfoPrevisional) {
      props.dispatch(setDataForms({
        ...props.jsonData,
        formInfoPrevisional: {},
      }));
    }
  }

  handleBack = () => {
    this.topRef.current.scrollIntoView();
    const jsonData = { ...this.props.jsonData };
    const step = jsonData.middleStepsEnabled ? 2 : 1;
    this.props.dispatch(setStep(step));
    this.props.dispatch(lastStep());
  }

  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      this.topRef.current.scrollIntoView();
      const jsonData = { ...this.props.jsonData };
      jsonData.step1Complete = this.props.jsonData.step1Complete;
      jsonData.step2Complete = this.props.jsonData.step2Complete;
      jsonData.step3Complete = true;
      jsonData.step4Complete = false;
      this.props.dispatch(setDataForms(jsonData));
      this.props.onSave(false);
      const step = 4;
      this.props.dispatch(setStep(step));
      this.props.dispatch(nextStep());
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };
    jsonData.formInfoPrevisional[e.element.id] = e.value;

    if (jsonData.formInfoPrevisional.checkAllMonth) {
      this.shareInfoAllMonth(jsonData.formInfoPrevisional.checkAllMonth);
    }

    if (e.element.id === "tipoPervisionSaludMesUno" && e.value === "Fonasa") {
      jsonData.formInfoPrevisional.codigoPrevisionMesUno = this.props.fonasa && this.props.fonasa.CodigoIsapre;
    } else if (e.element.id === "tipoPervisionSaludMesDos" && e.value === "Fonasa") {
      jsonData.formInfoPrevisional.codigoPrevisionMesDos = this.props.fonasa && this.props.fonasa.CodigoIsapre;
    } else if (e.element.id === "tipoPervisionSaludMesTres" && e.value === "Fonasa") {
      jsonData.formInfoPrevisional.codigoPrevisionMesTres = this.props.fonasa && this.props.fonasa.CodigoIsapre;
    }

    this.props.dispatch(setDataForms(jsonData));
  }
  shareInfoAllMonth = (value) => {
    const jsonData = { ...this.props.jsonData };
    const form = jsonData.formInfoPrevisional;
    const { monthsDisplay } = this.props.jsonData;
    const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });

    if (form.tipoPervisionSaludMesUno || form.codigoPrevisionMesUno ||
      form.valorPlanMesUno || form.unidadMesUno || form.afpMesUno || form.adjuntoAfiliacionMesUno) {
      if (monthsDisplay.length >= 2) {
        if (form.adjuntoAfiliacionMesDos != null
          && value === true && form.adjuntoAfiliacionMesDos !== form.adjuntoAfiliacionMesUno) {
          this.props.dispatch(doDeleteSingleFile({
            rutTrabajador: rutWorker,
            rutUsuario: this.props.userData.RUT,
            idPrestacion: jsonData.idFinancialBenefit,
            NombreArchivo: jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos,
            type: DocumentType.fun
          }, false));
        }


        form.tipoPervisionSaludMesDos = value === true ? form.tipoPervisionSaludMesUno : null;
        form.valorPlanMesDos = value === true ? form.valorPlanMesUno : null;
        form.unidadMesDos = value === true ? form.unidadMesUno : null;
        form.afpMesDos = value === true ? form.afpMesUno : null;
        form.adjuntoAfiliacionMesDos = value === true ? form.adjuntoAfiliacionMesUno : null;
        form.IsapreMesDos = value === true ? form.IsapreMesUno : null;
        form.codigoPrevisionMesDos = value === true ? form.codigoPrevisionMesUno : null;
      }
      if (monthsDisplay.length === 3) {
        if (form.adjuntoAfiliacionMesTres != null
          && form.adjuntoAfiliacionMesTres !== form.adjuntoAfiliacionMesUno && value === true) {
          this.props.dispatch(doDeleteSingleFile({
            rutTrabajador: rutWorker,
            rutUsuario: this.props.userData.RUT,
            idPrestacion: jsonData.idFinancialBenefit,
            NombreArchivo: jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres,
            type: DocumentType.fun
          }, false));
        }
        form.tipoPervisionSaludMesTres = value === true ? form.tipoPervisionSaludMesUno : null;
        form.valorPlanMesTres = value === true ? form.valorPlanMesUno : null;
        form.unidadMesTres = value === true ? form.unidadMesUno : null;
        form.afpMesTres = value === true ? form.afpMesUno : null;
        form.adjuntoAfiliacionMesTres = value === true ? form.adjuntoAfiliacionMesUno : null;
        form.IsapreMesTres = value === true ? form.IsapreMesUno : null;
        form.codigoPrevisionMesTres = value === true ? form.codigoPrevisionMesUno : null;
      }
    }


    form.checkAllMonth = value;
    jsonData.formInfoPrevisional = form;
    this.props.dispatch(setDataForms(jsonData));
  }
  handeChangeDctos = (e) => {
    const jsonData = { ...this.props.jsonData };

    const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
    jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;
    const data = {};
    data.rutTrabajador = rutWorker;
    data.rutUsuario = this.props.userData.RUT;
    data.idPrestacion = jsonData.idFinancialBenefit;
    data.type = DocumentType.fun;
    switch (e.element.id) {
      case "adjuntoAfiliacionMesUno": {
        if (e.value) {
          const archivo = e.value[0];

          data.files = archivo;
          if (jsonData.formInfoPrevisional.adjuntoAfiliacionMesUno != null
            && jsonData.formInfoPrevisional.adjuntoAfiliacionMesUno != "") {
            this.props.dispatch(doDeleteSingleFile({
              rutTrabajador: rutWorker,
              rutUsuario: this.props.userData.RUT,
              idPrestacion: jsonData.idFinancialBenefit,
              NombreArchivo: jsonData.formInfoPrevisional.adjuntoAfiliacionMesUno,
              type: DocumentType.fun
            }, false));
          }
          this.props.dispatch(doUploadFile(data, () => {
            jsonData.formInfoPrevisional.adjuntoAfiliacionMesUno = archivo.name;
          }));
          if (jsonData.formInfoPrevisional.checkAllMonth) {
            this.shareInfoAllMonth(jsonData.formInfoPrevisional.checkAllMonth);
          }
        }
        break;
      }

      case "adjuntoAfiliacionMesDos": {
        if (e.value) {
          const archivo = e.value[0];
          data.files = archivo;
          if (jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos != null
            && jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos != "") {
            this.props.dispatch(doDeleteSingleFile({
              rutTrabajador: rutWorker,
              rutUsuario: this.props.userData.RUT,
              idPrestacion: jsonData.idFinancialBenefit,
              NombreArchivo: jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos,
              type: DocumentType.fun
            }, false));
          }
          this.props.dispatch(doUploadFile(data, () => {
            jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos = archivo.name;
          }));
        }
        break;
      }

      case "adjuntoAfiliacionMesTres": {
        if (e.value) {
          const archivo = e.value[0];
          data.files = archivo;
          if (jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres != null
            && jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres != "") {
            this.props.dispatch(doDeleteSingleFile({
              rutTrabajador: rutWorker,
              rutUsuario: this.props.userData.RUT,
              idPrestacion: jsonData.idFinancialBenefit,
              NombreArchivo: jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres,
              type: DocumentType.fun
            }, false));
          }
          this.props.dispatch(doUploadFile(data, () => {
            jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres = archivo.name;
          }));
        }
        break;
      }

      default:
        break;
    }

    this.props.dispatch(setDataForms(jsonData));
  }
  eliminoDcto(dcto, property, tipo) {
    const jsonData = { ...this.props.jsonData };
    const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
    jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;
    jsonData.formInfoPrevisional[property] = null;

    if (property === "adjuntoAfiliacionMesUno") {
      if (jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos === dcto) jsonData.formInfoPrevisional.adjuntoAfiliacionMesDos = null;
      if (jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres === dcto) jsonData.formInfoPrevisional.adjuntoAfiliacionMesTres = null;
    }

    this.props.dispatch(doDeleteSingleFile({
      rutTrabajador: rutWorker,
      rutUsuario: this.props.userData.RUT,
      idPrestacion: jsonData.idFinancialBenefit,
      NombreArchivo: dcto,
      type: tipo
    }, true));
    this.props.dispatch(setDataForms(jsonData));
  }

  renderDocument = (nmbDcto, property, titulo, type) => {
    const list = this.props.listaDocumentosIngresados.filter((item) => item.Nombre === nmbDcto && item.tipo === type);
    return (
      <React.Fragment>
        <div style={{ marginBottom: 10, marginTop: 10 }}>
          <span className="title">  {titulo} </span>
          <List
            className="draf-document-list"
            scrollByContent
            selectedIndex={2}
            noDataText="Sin documentos"
            items={list}
            itemComponent={(item) => (
              <div className="list-document-wrapper">
                <div className="text">
                  <span className="text"> <i className="material-icons" style={{ fontSize: 10 }} > attach_file </i> {item.Nombre}</span>
                </div>

                <div style={{ paddingLeft: 5 }} >
                  <Button
                    stylingMode="text"
                    className="material-icons"
                    style={{
                      backgroundColor: "Transparent",
                      border: "none",
                    }}
                    key={`${item.Nombre}_eliminar`}
                    onClick={() => this.eliminoDcto(item.Nombre, property, item.tipo)}
                  >
                    <i className="material-icons" style={{ fontSize: 10 }} > delete </i>
                  </Button>
                </div>


              </div>
            )}
          />
        </div >
      </React.Fragment>
    );
  }

  render() {
    const form = { ...this.props.jsonData.formInfoPrevisional };
    const monthsDisplay = this.props.jsonData.monthsDisplay;


    return (
      <ValidationGroup className="row" >
        <div className="col-12 newDenuncia-title" ref={this.topRef}>
          <h2>Información del Previsional</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>
        {/* {monthsDisplay.length > 1 ?
          <div className="col-12" style={{ marginBottom: 10 }}>
            <CheckBox
              id="checkAllMonths"
              className="newDenuncia-subtitle"
              text="Repetir la información en todos los meses"
              value={form.checkAllMonth}
              onValueChanged={(check) => this.shareInfoAllMonth(check.value)}
            />
          </div>
          : <div></div>
        } */}

        <div className="col-12">
          {/* <h4 className="newDenuncia-subtitle"> Información previsional de {monthsDisplay[0]}
            {form.checkAllMonth === true && monthsDisplay.length >= 2 ? `- ${monthsDisplay[1]}` : null}
            {form.checkAllMonth === true && monthsDisplay.length === 3 ? `- ${monthsDisplay[2]}` : null}

          </h4> */}
          {/* <SelectField
            label="Previsón de salud"
            id="tipoPervisionSaludMesUno"
            required
            onValueChanged={this.handleChange}
            value={form && form.tipoPervisionSaludMesUno ? form.tipoPervisionSaludMesUno : null}
            items={["Isapre", "Fonasa", "Capredena"]}
          /> */}

          {/* {form.hasOwnProperty("tipoPervisionSaludMesUno") && form.tipoPervisionSaludMesUno === "Isapre" ?
            <React.Fragment>
              <SelectField
                label="Isapre"
                id="codigoPrevisionMesUno"
                value={form && form.codigoPrevisionMesUno ? form.codigoPrevisionMesUno : null}
                dataSource={this.props.listaIsapres}
                displayExpr="Isapre"
                valueExpr="CodigoIsapre"
                onValueChanged={this.handleChange}
              />
              <div className="row zero-vertical">
                <div className="col-8 zero-right">
                  <NumberField
                    label="Valor Plan"
                    required
                    min={0}
                    skipParse
                    id="valorPlanMesUno"
                    value={form.valorPlanMesUno || 0}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-4">
                  <SelectField
                    label="Unidad"
                    id="unidadMesUno"
                    required
                    value={form.unidadMesUno}
                    onValueChanged={this.handleChange}
                    items={["UF", "Pesos", "UTM"]}
                  />

                </div>
              </div>
              <FileUploaderField
                id="adjuntoAfiliacionMesUno"
                label="Adjuntar FUN o certificado de afiliación a isarpe"
                text="Adjuntar Archivo"
                multiple={false}
                required
                formats="application/pdf"
                maxFileSize={maxFileSize}
                uploadMode="useForm"
                onChange={this.handeChangeDctos}
                validar={form.adjuntoAfiliacionMesUno == null}
              />

              {
                form.adjuntoAfiliacionMesUno && this.renderDocument(form.adjuntoAfiliacionMesUno, "adjuntoAfiliacionMesUno", `Documento afiliación de ${monthsDisplay[0]}`, DocumentType.fun.toLowerCase())
              }
            </React.Fragment>
            :
            ""
          }


          <SelectField
            label="AFP"
            id="afpMesUno"
            value={form && form.afpMesUno ? form.afpMesUno : null}
            dataSource={this.props.listaAfp}
            displayExpr="Text"
            valueExpr="Cod"
            required
            onValueChanged={this.handleChange}
          /> */}

        </div>

        {/* {monthsDisplay.length >= 2 && form.checkAllMonth === false ?

          <div className="col-12">
            <h4 className="newDenuncia-subtitle"> Información previsional de {monthsDisplay[1]}</h4>
            <SelectField
              label="Previsón de salud"
              id="tipoPervisionSaludMesDos"
              required
              validation
              onValueChanged={this.handleChange}
              value={form && form.tipoPervisionSaludMesDos ? form.tipoPervisionSaludMesDos : null}
              items={["Isapre", "Fonasa", "Capredena"]}
            />
            {form.hasOwnProperty("tipoPervisionSaludMesDos") && form.tipoPervisionSaludMesDos === "Isapre" ?
              <React.Fragment>
                <SelectField
                  label="Isapre"
                  id="codigoPrevisionMesDos"
                  value={form && form.codigoPrevisionMesDos ? form.codigoPrevisionMesDos : null}
                  dataSource={this.props.listaIsapres}
                  displayExpr="Isapre"
                  required
                  validation
                  valueExpr="CodigoIsapre"
                  onValueChanged={this.handleChange}
                />
                <div className="row zero-vertical">
                  <div className="col-8 zero-right">
                    <NumberField
                      label="Valor Plan"
                      id="valorPlanMesDos"
                      required
                      min={0}
                      skipParse
                      value={form.valorPlanMesDos || 0}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-4">
                    <SelectField
                      label="Unidad"
                      id="unidadMesDos"
                      required
                      validation
                      value={form.unidadMesDos}
                      onValueChanged={this.handleChange}
                      items={["UF", "Pesos", "UTM"]}
                    />

                  </div>
                </div>
                <FileUploaderField
                  id="adjuntoAfiliacionMesDos"
                  label="Adjuntar FUN o certificado de afiliación a isarpe"
                  text="Adjuntar Archivo"
                  multiple={false}
                  validar
                  formats="application/pdf"
                  maxFileSize={maxFileSize}
                  required
                  uploadMode="useForm"
                  onChange={this.handeChangeDctos}
                  validar={form.adjuntoAfiliacionMesDos == null}
                />
                {
                  this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(form.adjuntoAfiliacionMesDos, "adjuntoAfiliacionMesDos", `Documento afiliación de ${monthsDisplay[1]}`, DocumentType.fun.toLowerCase())
                }
              </React.Fragment>
              :
              <div></div>
            }


            <SelectField
              label="AFP"
              id="afpMesDos"
              value={form && form.afpMesDos ? form.afpMesDos : null}
              dataSource={this.props.listaAfp}
              displayExpr="Text"
              required
              validation
              valueExpr="Cod"
              onValueChanged={this.handleChange}
            />

          </div>
          :
          <div></div>

        } */}


        {/* {monthsDisplay.length === 3 && form.checkAllMonth === false ? */}

          <div className="col-12">
            {/* <h4 className="newDenuncia-subtitle"> Información previsional de {monthsDisplay[2]}</h4> */}
            <SelectField
              label="Previsón de salud"
              id="tipoPervisionSaludMesTres"
              required
              onValueChanged={this.handleChange}
              value={form && form.tipoPervisionSaludMesTres ? form.tipoPervisionSaludMesTres : null}
              items={["Isapre", "Fonasa", "Capredena"]}
            />
            {form.hasOwnProperty("tipoPervisionSaludMesTres") && form.tipoPervisionSaludMesTres === "Isapre" ?
              <React.Fragment>
                <SelectField
                  label="Isapre"
                  id="codigoPrevisionMesTres"
                  value={form && form.codigoPrevisionMesTres ? form.codigoPrevisionMesTres : null}
                  dataSource={this.props.listaIsapres}
                  displayExpr="Isapre"
                  required
                  valueExpr="CodigoIsapre"
                  onValueChanged={this.handleChange}
                />
                <div className="row zero-vertical">
                  <div className="col-8 zero-right">
                    <NumberField
                      label="Valor Plan"
                      id="valorPlanMesTres"
                      required
                      min={0}
                      skipParse
                      value={form.valorPlanMesTres || 0}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-4">
                    <SelectField
                      label="Unidad"
                      id="unidadMesTres"
                      required
                      value={form.unidadMesTres}
                      onValueChanged={this.handleChange}
                      items={["UF", "Pesos", "UTM"]}
                    />

                  </div>
                </div>
                <FileUploaderField
                  id="adjuntoAfiliacionMesTres"
                  label="Adjuntar FUN o certificado de afiliación a isarpe"
                  text="Adjuntar Archivo"
                  multiple={false}
                  required
                  validar
                  formats="application/pdf"
                  maxFileSize={maxFileSize}
                  uploadMode="useForm"
                  onChange={this.handeChangeDctos}
                  validar={form.adjuntoAfiliacionMesTres == null}
                />
                {
                  this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(form.adjuntoAfiliacionMesTres, "adjuntoAfiliacionMesTres", `Documento afiliación de ${monthsDisplay[2]}`, DocumentType.fun.toLowerCase())
                }
              </React.Fragment>
              :
              <div></div>
            }


            <SelectField
              label="AFP"
              id="afpMesTres"
              value={form && form.afpMesTres ? form.afpMesTres : null}
              dataSource={this.props.listaAfp}
              displayExpr="Text"
              validation
              required
              valueExpr="Cod"
              onValueChanged={this.handleChange}
            />

          </div>
          {/* // :
          // <div></div>
        // } */}


        <div className="col-12">
          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>

      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.prestacionesEmpresa.jsonData,
  listaAfp: state.global.listaAfp,
  listaIsapres: state.global.listaIsapres && state.global.listaIsapres.filter((i) => i.Isapre !== "FONASA"),
  fonasa: state.global.listaIsapres && state.global.listaIsapres.find((i) => i.Isapre === "FONASA"),
  userData: state.global.userData,
  listaDocumentosIngresados: state.prestacionesEmpresa.listaDocumentosIngresados,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoPrevisional);
